import { render } from "./ExamAiAssistantPatientIntroVideo.vue?vue&type=template&id=b4edb1ec&scoped=true"
import script from "./ExamAiAssistantPatientIntroVideo.vue?vue&type=script&lang=js"
export * from "./ExamAiAssistantPatientIntroVideo.vue?vue&type=script&lang=js"

import "./ExamAiAssistantPatientIntroVideo.vue?vue&type=style&index=0&id=b4edb1ec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4edb1ec"]])

export default __exports__